'use strict';

(function ($, Drupal) {
  var DROPDOWN_SELECTOR = '.faq-dropdown';
  var TOGGLE_SELECTOR = '.dropdown-toggle';
  var TOGGLABLE_SELECTOR = '.dropdown-togglable';
  var initialized = false;

  Drupal.behaviors.faqDropDown = {
    attach: function (context, settings) {
      if (initialized) { return; }
      initialized = true;
      $(DROPDOWN_SELECTOR).each(function () {
        var $elem = $(this);
        $elem.find(TOGGLABLE_SELECTOR).hide();
        $elem.find(TOGGLE_SELECTOR).click(function (event) {
          event.preventDefault();
          var $toggle = $(this);
          $toggle.toggleClass('dropdown-toggled')
          $toggle.closest(DROPDOWN_SELECTOR).find(TOGGLABLE_SELECTOR).slideToggle();
        });
      });
    }
  };

})(jQuery, Drupal);
